// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","copyright":"Footer_copyright__2WB24"};